function extendAPI(api) {
    return {
        removeDownload: async (downloadId, options) => {
            return new Promise((resolve, reject) => {
                api.events.emit("remove-download", downloadId, (err) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                }, options);
            });
        },
        pauseDownload: async (downloadId) => {
            return new Promise((resolve, reject) => {
                api.events.emit("pause-download", downloadId, (err) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                });
            });
        },
        resumeDownload: async (downloadId, options) => {
            return new Promise((resolve, reject) => {
                api.events.emit("resume-download", downloadId, (err) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                }, options);
            });
        },
        startDownload: async (urls, modInfo, fileName, redownload, options) => {
            return new Promise((resolve, reject) => {
                api.events.emit("start-download", urls, modInfo, fileName, (err, result) => {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(result);
                    }
                }, redownload, options);
            });
        },
    };
}
export default extendAPI;
